import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class PageFeaturedProject extends Component {
	
	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	} 
  	
	render () {
		
		let project = this.props.project;
		
		console.log('project');
		console.log(project);
				
		if (project) {
						
		    return (
			    			    
			    <Link to={{ pathname: project.url }} className={'c-featured-projects__item ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
			    	<div className="c-featured-projects__item__inner">
						<p className="c-featured-projects__item__title" dangerouslySetInnerHTML={ {__html: '<span class="c-featured-projects__item__title__text">' + project.heading + '</span>'}}></p>
					</div>		    													    
			    </Link>
			)
			
		} else {
			
			return null;
		
		}
	}
}
